import { render, staticRenderFns } from "./was_ist.vue?vue&type=template&id=feede5e8&scoped=true&"
import script from "./was_ist.vue?vue&type=script&lang=js&"
export * from "./was_ist.vue?vue&type=script&lang=js&"
import style0 from "./was_ist.vue?vue&type=style&index=0&id=feede5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feede5e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
